document.addEventListener('DOMContentLoaded', function () {
    const consentBox =
        document.querySelector(".consent-cookie");
    const acceptBtn =
        document.querySelector(".consent-cookie-btn");

    acceptBtn.onclick = () => {
        document.cookie = "CookieBy=proof; max-age="
            + 60 * 60 * 24;
        if (document.cookie) {
            consentBox.classList.add("hide");
        }
    };

    let checkCookie =
        document.cookie.indexOf("CookieBy=proof");
    checkCookie !== -1 ? consentBox.classList.add("hide") :
        consentBox.classList.remove("hide");
})